<template>
  <el-dialog :visible="visible" :title="title" :before-close="beforeClose">
    <t-form ref="form" @change="handleFormChange" />

    <div slot="footer">
      <el-button type="primary" @click="submit" :loading="pending">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TForm from './forms/start-form'
import debounce from 'lodash/debounce'

export default {
  props: {
    title: {
      type: String,
      default: '上传房东合同照片',
    },

    defaultForm: Object,
  },

  components: {
    TForm,
  },
  provide () {
    return {
      defaultForm: this.defaultForm,
    }
  },

  data () {
    this.form = {}
    this.submit = debounce(this._submit, 1000)
    return {
      visible: true,
      pending: false,
    }
  },

  methods: {
    beforeClose () {
      this.emitClose()
    },

    emitClose () {
      this.$emit('close')
    },

    handleFormChange (form, formEl) {
      console.log('change事件');
      this.form = form
    },

    _submit () {
      this.formEl = this.$refs.form
      if (this.formEl) {
        this.formEl.submit(
          () => {
            this.emitClose()
            this.$root.bus.$emit('refreshTask')
          },
          () => {
            this.pending = false
          },
          () => {
            this.pending = true
          }
        )
      }
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/none/workflow/trusteeship/start-dialog.vue